var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNestedDropdownAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4d4f5c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(151 310) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.5,0,13,6H0Z",
    transform: "translate(138 296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.5,0,13,6H0Z",
    transform: "translate(138 304)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestedDropdownAll);
export default __webpack_public_path__ + "static/media/nested-dropdown-all.99402478493a21fd3124f14fcd13e930.svg";
export { ForwardRef as ReactComponent };